import { useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three' 

export default function ViewCone (props) {
    var size = 1.0;
    
    return (
        <mesh {...props}>
            <coneGeometry args={[6, 8, 16]} />
            <meshBasicMaterial color={0xffffff} wireframe />
        </mesh>
    )
}